import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import { Link } from 'react-router-dom';
import {
  getSocialConfig,
  saveSocialConfig,
} from '../../sagas/socialMediaSaga/reducer';
import { getDefaultPlatformConfigs } from '../../services/SocialMediaServices';

export class AdminSocialMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      platforms: [],
      newPlatformName: '',
      expandedPlatformId: null,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.user.authenticated === false) {
      this.props.history.push('/login');
      return;
    }

    if (
      this.props.user.authenticated === true &&
      this.props.profile.userType !== 1
    ) {
      this.props.history.push('/');
    }
  }

  componentDidMount() {
    this.props.getSocialConfig();
    try {
      const cached = localStorage.getItem('socialPlatformConfigs');
      if (
        cached &&
        (!this.props.platforms || this.props.platforms.length === 0)
      ) {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed) && parsed.length > 0) {
          this.setState({
            platforms: parsed,
            expandedPlatformId: parsed[0].id,
          });
        }
      }
    } catch (e) {
      // localStorage unavailable
    }
    this.setState({
      loading: false,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.platforms !== this.props.platforms) {
      const nextPlatforms = this.props.platforms.map((platform) => ({
        ...platform,
      }));

      const currentIds = nextPlatforms.map((item) => item.id);
      const hasCurrentExpanded = currentIds.includes(
        this.state.expandedPlatformId,
      );

      this.setState({
        platforms: nextPlatforms,
        expandedPlatformId:
          hasCurrentExpanded || nextPlatforms.length === 0
            ? this.state.expandedPlatformId
            : nextPlatforms[0].id,
      });
    }
  }

  getTitleBar() {
    return (
      <div id="headersTop">
        <div className="backbar">
          <Row className="no-margin">
            <Col lg={2} md={2} sm={2} xs={2} className="no-padding">
              <Link
                to={{
                  pathname: '/vendor/home',
                }}
                className="left"
              >
                <MaterialIcon
                  icon="keyboard_backspace"
                  size={25}
                  color="white"
                />
              </Link>
            </Col>
            <Col lg={8} md={8} sm={8} xs={8}>
              <center>
                <span className="page-header">Social Config</span>
              </center>
            </Col>
            <Col lg={2} md={2} sm={2} xs={2}></Col>
          </Row>
        </div>
      </div>
    );
  }

  updatePlatform(index, key, value) {
    const platforms = [...this.state.platforms];
    platforms[index] = {
      ...platforms[index],
      [key]: value,
    };

    this.setState({
      platforms,
    });
  }

  addPlatform() {
    if (this.state.newPlatformName.trim() === '') {
      return;
    }

    const id = this.state.newPlatformName
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');

    const newPlatform = {
      id,
      name: this.state.newPlatformName.trim(),
      active: true,
      order: this.state.platforms.length + 1,
      textMaxChars: 280,
      mediaMaxItems: 1,
      imageMaxMB: 10,
      videoMaxMB: 100,
      supportsScheduling: false,
      sourceConfidence: 'needs_verification',
    };

    this.setState({
      platforms: [...this.state.platforms, newPlatform],
      newPlatformName: '',
    });
  }

  saveConfig() {
    let updatedBy = '';
    if (this.props.profile && this.props.profile.userName) {
      updatedBy = this.props.profile.userName;
    }
    this.props.saveSocialConfig(this.state.platforms, updatedBy);
    console.log('Save config (DB write skipped)', {
      platforms: this.state.platforms,
      updatedBy,
    });
    try {
      localStorage.setItem(
        'socialPlatformConfigs',
        JSON.stringify(this.state.platforms),
      );
    } catch (e) {
      // localStorage unavailable
    }
  }

  loadDefaultPlatforms(saveImmediately = false) {
    const defaults = getDefaultPlatformConfigs().map((platform) => ({
      ...platform,
    }));

    this.setState(
      {
        platforms: defaults,
        expandedPlatformId:
          defaults.length > 0 ? defaults[0].id : null,
      },
      () => {
        if (saveImmediately) {
          this.saveConfig();
        }
      },
    );
  }

  togglePlatformAccordion(platformId) {
    this.setState((prevState) => ({
      expandedPlatformId:
        prevState.expandedPlatformId === platformId
          ? null
          : platformId,
    }));
  }

  renderPlatformEditor() {
    return (
      <div className="section">
        <h3>Platforms</h3>
        <p>
          Edit limits and capability flags. Changes save to Firestore
          and are used by the vendor social composer.
        </p>
        <div style={{ marginBottom: '12px' }}>
          <button
            className="cancelButton"
            style={{ marginRight: '8px' }}
            onClick={() => {
              this.loadDefaultPlatforms(false);
            }}
          >
            Load Default Platforms
          </button>
          <button
            className="redbutton"
            style={{ marginTop: '0px' }}
            onClick={() => {
              this.loadDefaultPlatforms(true);
            }}
          >
            Prepopulate & Save Defaults
          </button>
        </div>

        {this.state.platforms.map((platform, index) => {
          const isOpen =
            this.state.expandedPlatformId === platform.id;

          return (
            <div
              key={platform.id + index}
              style={{
                border: '1px solid #e6e6e6',
                borderRadius: '8px',
                marginBottom: '10px',
                background: '#fff',
                overflow: 'hidden',
              }}
            >
              <button
                style={{
                  width: '100%',
                  border: 'none',
                  background: '#fff',
                  padding: '12px',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
                onClick={() => {
                  this.togglePlatformAccordion(platform.id);
                }}
              >
                <div>
                  <div style={{ fontWeight: 700 }}>
                    {platform.name}
                  </div>
                  <small>
                    {platform.active ? 'Active' : 'Inactive'}
                    {' | '}Text: {platform.textMaxChars || 0}
                    {' | '}Media: {platform.mediaMaxItems || 0}
                    {' | '}Image: {platform.imageWidth || 0} x{' '}
                    {platform.imageHeight || 0}
                  </small>
                </div>
                <MaterialIcon
                  icon={isOpen ? 'expand_less' : 'expand_more'}
                  size={24}
                  color="#353535"
                />
              </button>

              {isOpen && (
                <div
                  style={{
                    padding: '12px',
                    borderTop: '1px solid #f0f0f0',
                  }}
                >
                  <Row>
                    <Col xs={12} md={3} sm={3} lg={3}>
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={platform.name || ''}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'name',
                            event.target.value,
                          );
                        }}
                      />
                    </Col>
                    <Col xs={6} md={2} sm={2} lg={2}>
                      <label>Text Max</label>
                      <input
                        type="number"
                        className="form-control"
                        value={platform.textMaxChars || 0}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'textMaxChars',
                            Number(event.target.value),
                          );
                        }}
                      />
                    </Col>
                    <Col xs={6} md={2} sm={2} lg={2}>
                      <label>Media Max</label>
                      <input
                        type="number"
                        className="form-control"
                        value={platform.mediaMaxItems || 1}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'mediaMaxItems',
                            Number(event.target.value),
                          );
                        }}
                      />
                    </Col>
                    <Col xs={6} md={2} sm={2} lg={2}>
                      <label>Image MB</label>
                      <input
                        type="number"
                        className="form-control"
                        value={platform.imageMaxMB || 0}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'imageMaxMB',
                            Number(event.target.value),
                          );
                        }}
                      />
                    </Col>
                    <Col xs={6} md={2} sm={2} lg={2}>
                      <label>Video MB</label>
                      <input
                        type="number"
                        className="form-control"
                        value={platform.videoMaxMB || 0}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'videoMaxMB',
                            Number(event.target.value),
                          );
                        }}
                      />
                    </Col>
                    <Col xs={6} md={1.5} sm={1.5} lg={1.5}>
                      <label>Img W (px)</label>
                      <input
                        type="number"
                        className="form-control"
                        value={platform.imageWidth || 0}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'imageWidth',
                            Number(event.target.value),
                          );
                        }}
                      />
                    </Col>
                    <Col xs={6} md={1.5} sm={1.5} lg={1.5}>
                      <label>Img H (px)</label>
                      <input
                        type="number"
                        className="form-control"
                        value={platform.imageHeight || 0}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'imageHeight',
                            Number(event.target.value),
                          );
                        }}
                      />
                    </Col>
                    <Col xs={12} md={1} sm={1} lg={1}>
                      <label>Active</label>
                      <div>
                        <input
                          type="checkbox"
                          checked={platform.active === true}
                          onChange={(event) => {
                            this.updatePlatform(
                              index,
                              'active',
                              event.target.checked,
                            );
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col xs={6} md={2} sm={2} lg={2}>
                      <label>Order</label>
                      <input
                        type="number"
                        className="form-control"
                        value={platform.order || index + 1}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'order',
                            Number(event.target.value),
                          );
                        }}
                      />
                    </Col>
                    <Col xs={6} md={3} sm={3} lg={3}>
                      <label>Source Confidence</label>
                      <select
                        className="form-control"
                        value={platform.sourceConfidence || 'derived'}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'sourceConfidence',
                            event.target.value,
                          );
                        }}
                      >
                        <option value="official">official</option>
                        <option value="official-partial">
                          official-partial
                        </option>
                        <option value="derived">derived</option>
                        <option value="needs_verification">
                          needs_verification
                        </option>
                      </select>
                    </Col>
                    <Col xs={12} md={7} sm={7} lg={7}>
                      <label>Notes</label>
                      <input
                        type="text"
                        className="form-control"
                        value={platform.notes || ''}
                        onChange={(event) => {
                          this.updatePlatform(
                            index,
                            'notes',
                            event.target.value,
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          );
        })}

        <div
          style={{
            border: '1px dashed #d2d2d2',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '15px',
            background: '#fafafa',
          }}
        >
          <label>Add Platform</label>
          <Row>
            <Col xs={12} md={9} sm={9} lg={9}>
              <input
                type="text"
                className="form-control"
                placeholder="Platform name"
                value={this.state.newPlatformName}
                onChange={(event) => {
                  this.setState({
                    newPlatformName: event.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={12} md={3} sm={3} lg={3}>
              <button
                className="redbutton"
                style={{ width: '100%', marginTop: '0px' }}
                onClick={() => {
                  this.addPlatform();
                }}
              >
                Add
              </button>
            </Col>
          </Row>
        </div>

        <button
          className="redbutton"
          onClick={() => {
            this.saveConfig();
          }}
        >
          {this.props.socialMedia.saving
            ? 'Saving...'
            : 'Save Config'}
        </button>

        {this.props.socialMedia.saveSuccess && (
          <p style={{ color: '#138a36', marginTop: '10px' }}>
            Saved.
          </p>
        )}
        {this.props.socialMedia.error && (
          <p style={{ color: '#d93025', marginTop: '10px' }}>
            {this.props.socialMedia.error}
          </p>
        )}
      </div>
    );
  }

  render() {
    return (
      <div id="admin">
        {this.getTitleBar()}
        {this.renderPlatformEditor()}
        <style
          dangerouslySetInnerHTML={{
            __html:
              '.authtoolbar { display: none } #headers { top: 0px !important;} .maincontent{top: 0px !important;} #bottomNav{display:none} #loadscreen p{color:white}',
          }}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getSocialConfig: () => {
      dispatch(getSocialConfig());
    },
    saveSocialConfig: (configs, updatedBy) => {
      dispatch(saveSocialConfig(configs, updatedBy));
    },
  };
};

function mapStateToProps(state) {
  return {
    user: state.user,
    profile: state.profile.profile,
    socialMedia: state.socialMedia,
    platforms: state.socialMedia.platforms,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminSocialMedia);
